// The two date shapes Person Detail talks in.
//
// `<input type="date">` speaks ISO 'YYYY-MM-DD', and so does
// CrmVehicle.expiration_date (a DateField) — those pass through untouched.
// OpportunitySerializer reads *and* writes maturity_date as 'MM/DD/YYYY' only,
// so that one is converted at the wire boundary.
//
// Both conversions are string surgery on purpose. Routing a date-only value
// through `new Date()` re-reads it as UTC midnight and renders the previous day
// west of Greenwich — the one-day shift these exist to avoid.

// 'YYYY-MM-DD' -> 'MM/DD/YYYY'. Lifted out of MarkSoldModal, which still uses it.
export const toMDY = (iso) => {
    if (!iso) return ''
    const [y, m, d] = String(iso).split('-')
    if (!y || !m || !d) return ''
    return `${m}/${d}/${y}`
}

// 'MM/DD/YYYY' -> 'YYYY-MM-DD', for prefilling a date input from the API.
// An already-ISO value is handed back as-is: a blank prefill would read as
// "no expiration on record", which is a different fact from the one we hold.
export const toISODate = (raw) => {
    if (!raw) return ''
    const value = String(raw)
    if (value.includes('-')) return value.slice(0, 10)
    const [m, d, y] = value.split('/')
    if (!y || !m || !d) return ''
    return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`
}
